var exports = {
  "Wm": "dropdown__Oh5TKv",
  "Md": "commandLabel__raeteE",
  "ET": "commandDescription__5nrGIG",
};

module.exports = exports;
